import { render, staticRenderFns } from "./AccidentListExpand.vue?vue&type=template&id=28d90879&scoped=true&"
import script from "./AccidentListExpand.vue?vue&type=script&lang=js&"
export * from "./AccidentListExpand.vue?vue&type=script&lang=js&"
import style0 from "./AccidentListExpand.vue?vue&type=style&index=0&id=28d90879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d90879",
  null
  
)

export default component.exports